var _path, _ellipse, _path2, _ellipse2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngryPack6 = function SvgAngryPack6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 70.888c55.284 13.621 40.395 54.417 26.039 73.112 16.025 21.633-1.335 35.721-12.018 40.061-9.615 53.682-52.747 43.734-73.112 32.049-28.844 4.808-42.064-14.689-45.069-25.038-36.856-6.41-36.722-37.39-32.049-52.079-25.639-42.465 10.683-63.097 32.05-68.105 13.62-37.657 45.736-24.37 60.091-13.02 20.832-14.422 38.058 2.671 44.068 13.02Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.853,
    cy: 121.594,
    rx: 22.276,
    ry: 29.701,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m92.715 114.169 20.11 18.563m1.547-18.563-21.657 18.563",
    stroke: "#000",
    strokeWidth: 5.26,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.254,
    cy: 121.594,
    rx: 22.276,
    ry: 29.701,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m152.116 114.169 20.11 18.563m1.547-18.563-21.657 18.563",
    stroke: "#000",
    strokeWidth: 5.26,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.413 188.893h-36.464c-1.928 0-3.497-1.563-3.377-3.486.766-12.238 5.619-31.412 20.826-31.412 15.137 0 20.965 19 22.377 31.245.228 1.982-1.367 3.653-3.362 3.653Z",
    stroke: "#fff",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.234 161.008c-2.805 11.22-10.098 49.089-5.61 65.919m0 0c-.935 1.403-2.805 4.769-2.805 7.013m2.805-7.013v11.221m0-11.221c.935 3.273 2.805 10.379 2.805 12.623m-2.805-12.623c.935.468 3.086 2.525 4.208 7.013M203.696 161.008c2.805 11.22 10.098 49.089 5.61 65.919m0 0c.935 1.403 2.805 4.769 2.805 7.013m-2.805-7.013v11.221m0-11.221c-.935 3.273-2.805 10.379-2.805 12.623m2.805-12.623c-.935.468-3.086 2.525-4.208 7.013",
    stroke: "#000",
    strokeWidth: 1.964,
    strokeLinecap: "round"
  })));
};
export default SvgAngryPack6;